import WebsiteModal from "./WebsiteModal";

export default class VideoModal extends WebsiteModal {
    constructor(videoId, videoProvider) {
        super({
            close: {
                background: false,
            },
        });
        this.videoId = videoId;
        this.videoProvider = videoProvider;
        this.videoSrc = false;

        if (this.videoProvider === 1) {
            this.videoSrc = "https://www.youtube.com/embed/" + this.videoId;
        } else {
            this.videoSrc = "https://player.vimeo.com/video/" + this.videoId;
        }
    }

    buildElement() {
        this.$modal = (
            eotwJSXFactory('div', {className: "modal modal--loading"}, [
                eotwJSXFactory('div', {className: "modal__overlay js-close-modal"}),
                eotwJSXFactory('div', {className: "modal__container"}, [
                    eotwJSXFactory('div', {className: "modal__content"})
                ]),
                eotwJSXFactory('button', {className: "modal__close-btn js-close-modal", title: "Close", 'aria-label': "Close Modal"})
            ])
        );
        this.$modal.addClass('modal--video').find(".modal__content").append(
            eotwJSXFactory('div', {className: 'modal__video'}, [
                eotwJSXFactory('iframe', {src: this.videoSrc, title: "Video player", frameBorder: "0", allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture", allowFullScreen: true})
            ])
        );
    }

    destroy() {
        super.destroy();
    }
}
